import React, { useState, useCallback } from "react";

// libs
import { Row, Spin, Tooltip, Icon, Col } from "antd";
import moment from "moment";

// Styles
import { Card } from "../../styles";

// Components
import useKpiContext from "../../../../hooks/useKpiContext";

//Services
import { numberMask } from "../../../../services/helpersMethodsService";

//Icons
import AlertIcon from "../../icons/alert";
import ChartIcon from "../../icons/chart";
import InfoIcon from "../../../../components/utils/icons/info";

const KpiCost = () => {
  const { kpiCost: kpiData, updateKpiSelected } = useKpiContext();
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const [isTooltipErrorVisible, setIsTooltipErrorVisible] = useState(false);

  const handleShowTooltip = useCallback(() => {
    setIsTooltipVisible(true);
    setTimeout(() => {
      setIsTooltipVisible(false);
    }, 2000);
  }, []);

  const handleShowTooltipError = useCallback(() => {
    setIsTooltipErrorVisible(true);
    setTimeout(() => {
      setIsTooltipErrorVisible(false);
    }, 2000);
  }, []);

  return (
    <Card
      xs={23}
      sm={23}
      md={23}
      lg={7}
      xl={7}
      className={
        (kpiData?.data?.isComplete
          ? kpiData?.data?.goalAchieved
            ? " border-bottom-green"
            : " border-bottom-red"
          : "") +
        (kpiData.isSelected
          ? kpiData?.data?.isComplete
            ? kpiData?.data?.goalAchieved
              ? " border-green"
              : " border-red"
            : " border-yellow"
          : "")
      }
      onClick={() => (!kpiData.isLoading ? updateKpiSelected("CUSTO") : null)}
    >
      <Spin spinning={kpiData.isLoading} size="small">
        <div className="header">
          <span>
            <Tooltip
              visible={isTooltipErrorVisible}
              title={`Último processamento: ${
                kpiData.data?.kpiDate != null
                  ? moment(kpiData.data.kpiDate).format("DD/MM/YYYY")
                  : "Sem data"
              }`}
            >
              {kpiData.data.error ? (
                <Icon
                  type="exclamation-circle"
                  className="iconError"
                  theme="filled"
                  onClick={() => handleShowTooltipError()}
                />
              ) : null}
            </Tooltip>
            CUSTO PRODUÇÃO
          </span>
          <span>
            {!kpiData?.data?.isComplete ? null : kpiData?.data?.goalAchieved ? (
              <ChartIcon />
            ) : (
              <AlertIcon />
            )}
          </span>
        </div>

        <div className="content">
          <Row style={{ width: "100%" }} type="flex" justify="space-between">
            <Col span={12}>
              <Tooltip
                visible={isTooltipVisible}
                title="Custo Aquisição + Custo Adm/Operac. + Custo Nutrição por Arroba dos animais ativos."
              >
                <span className="span-font">
                  <b>
                    {kpiData?.data?.kpiValue == null
                      ? "-"
                      : numberMask(
                          kpiData?.data?.kpiValue || 0,
                          kpiData?.data?.isMonetary
                        )}{" "}
                  </b>
                  {kpiData?.data?.valueType}
                </span>
              </Tooltip>
            </Col>
            <Col span={12}>
              <Tooltip
                visible={isTooltipVisible}
                placement="right"
                title="Valor @ atual da curva padrão."
              >
                <span className="span-font">
                  <b>
                    {numberMask(
                      kpiData.data?.parameters?.MarketValue || 0,
                      true
                    )}
                  </b>
                  {" @"}
                </span>
              </Tooltip>
            </Col>
          </Row>
          <Row type="flex">
            <InfoIcon onClick={() => handleShowTooltip()} />
          </Row>
        </div>
        <div className="content-footer in-column">
          <Row style={{ width: "100%" }} type="flex">
            <Col span={12}>
              <Row style={{ width: "100%" }} type="flex" align="middle">
                <span className="title-parameter">Aquisição: </span>
                <span>
                  <b>
                    {`${numberMask(
                      kpiData.data?.parameters?.AverageAcquisitionCost || 0,
                      true
                    )} (${numberMask(
                      kpiData.data?.parameters?.PercentageAcquisitionCost *
                        100 || 0,
                      false
                    )}%)`}
                  </b>
                </span>
              </Row>
              <Row style={{ width: "100%" }} type="flex" align="middle">
                <span className="title-parameter">Dieta: </span>
                <span>
                  <b>
                    {`${numberMask(
                      kpiData.data?.parameters?.AverageDietCost || 0,
                      true
                    )} (${numberMask(
                      kpiData.data?.parameters?.PercentageDietCost * 100 || 0,
                      false
                    )}%)`}
                  </b>
                </span>
              </Row>
              <Row style={{ width: "100%" }} type="flex" align="middle">
                <span className="title-parameter">Adm/Operac.: </span>
                <span>
                  <b>
                    {`${numberMask(
                      kpiData.data?.parameters
                        ?.AverageFixedAndOperationalCost || 0,
                      true
                    )} (${numberMask(
                      kpiData.data?.parameters
                        ?.PercentageFixedAndOperationalCost * 100 || 0,
                      false
                    )}%)`}
                  </b>
                </span>
              </Row>
            </Col>
            <Col span={12}>
              <Row style={{ width: "100%" }} type="flex" align="middle">
                <Tooltip
                  visible={isTooltipVisible}
                  placement="bottom"
                  title="Custo @ Produzida: Dieta + Custos Adm/Op."
                >
                  <span className="title-parameter">Custo/@ Prod:</span>
                  <span>
                    <b>
                      {numberMask(
                        kpiData.data?.parameters?.CostArrobaProduced || 0,
                        true
                      )}{" "}
                    </b>
                    / @
                  </span>
                </Tooltip>
              </Row>
            </Col>
          </Row>
        </div>
      </Spin>
      {!kpiData?.data?.isComplete ? <div className="banner-image" /> : null}
    </Card>
  );
};

export default KpiCost;
